/**
 * 
 * key
 * 
 */


const key = 'ZXZlbnRNb250aFdpc2VQcm9kdWN0U3RhdHVzUmVwb3J0'

export default key 